import React from "react";
import BalanceMinutesSpentBody from "./BalanceMinutesSpentBody";

const BalanceMinutesSpent: React.FC = () => {
    return (
        <>
            <div className="row align-items-start">
                <div className="col">
                    <h2>Spent</h2>
                    <p>
                        Your spent values. These are the jobs that you have had
                        created and were finished.
                    </p>
                </div>
            </div>
            <BalanceMinutesSpentBody />
        </>
    );
};

export default BalanceMinutesSpent;
